/// <reference types="vite-plugin-svgr/client" />
import React from 'react';
import ReactDOM from 'react-dom/client';
import 'styled-system/styles.css';
import '@/common/assets/css/font.css';
import App from '@/App.tsx';
import '@/main.css';
import clarity from '@microsoft/clarity';
import './instrument';
import { initOpenReplay, openReplayKey } from './common/utils/initOpenReplay';

// Initializing Clarity configuration
if (
  (window as any)?.env?.VITE_PROJECT_KEY ||
  import.meta.env.VITE_PROJECT_KEY
) {
  clarity.init(
    (window as any)?.env?.VITE_PROJECT_KEY || import.meta.env.VITE_PROJECT_KEY,
  );
}

// Initializing OpenReplay configuration
if (openReplayKey) initOpenReplay();

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
